import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import he from 'he'
import {
	Row,
	Col,
	Pagination,
	Affix,
	Spin,
	Progress,
	Button,
	Alert,
	Icon,
	Badge,
	Dropdown,
	Menu,
	Input,
	Select,
	Checkbox,
	Slider,
	Card,
	message,
} from 'antd'

import apiPath from 'apiPath'
import moment from 'components/momentWithZone'
import ProgramCardList from 'components/Portal/FieldPrograms/ProgramCardList'
import parseJSON from 'components/Portal/FieldPrograms/parseJSON'

export default class PreviewProgram extends React.Component {
	state = {
		error: false,
		loading: false,
		page: 1,
		totalPrograms: 0,
		programs: [],
		cart: [],
		programImages: {},
		displayPageSize: 24,
		categories: [],
		inventory: {},
		inventoryLoaded: false,
		voyageid: 0,
		programcode: '',
		IDtoCode: {},
		portOrder: [],
		defaultFilters: {
			title: '',
			port: [],
			day: [],
			duration: [],
			category: [],
			price: [],
		},
		filters: {
			title: '',
			port: [],
			day: [],
			duration: [],
			category: [],
			price: [],
		},
		displayFilters: {
			title: '',
			port: [],
			day: [],
			duration: [],
			category: [],
			price: [],
		},
		maxPrice: 3000,
		loadProgress: 0,
		loadingImages: [],
		ports: [],
	}

	loadFieldProgramsIntoSessionstorage = () => {
		this.setState({ loading: true })
		this._interval = window.setInterval(() => {
			let speed = 0.01
			if (this.state.loadProgress + speed <= 0.12) {
				this.setState({ loadProgress: this.state.loadProgress + speed })
			}
		}, 300)

		this.getPrograms(this.props.booking.EventId, (progress) => {
			this.setState({ loadProgress: progress })
		})
			.catch((error) => {
				console.error(error)
				stickyError('Failed to load programs', 0, true)
			})
			.then((result) => {
				this.setState({ loading: false })
				this.getFieldPrograms(1)
				window.clearInterval(this._interval)
			})
	}

	filterSelectOptions = (inputValue, option) => {
		const s =
			typeof option.props.children === 'string'
				? option.props.children
				: option.props.children.join(' ')
		return s.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
	}

	getCategories = () => {
		// only show a checkbox for GSCE
		this.setState({
			categories: [
				{ key: 'GSCE', label: 'Global Studies Credit Eligible' },
			],
		})
	}

	getPrograms = (voyage) => {
		return new Promise((resolve, reject) => {
			axios
				.get(apiPath + '/fieldAdmin/getFieldPrograms', {
					params: { voyageId: voyage, verbose: true },
				})
				.then((response) => {
					const data = response.data.map((program) => {
						program.trip_types = [] //TODO: Trip Types = where does this info come from? Type are IsLeanIn, Is Strenuous, IsFastPaced but are notated by a series of numbers

						return program
					})

					resolve(data)
				})
				.catch(reject)
		})
	}

	getProgamsSimple = (voyage, fieldprogram) => {
		axios
			.get(apiPath + '/fieldAdmin/getFieldPrograms', {
				params: { voyageId: voyage, verbose: true },
			})
			.then((response) => {
				let data = response.data.map((program) => {
					program.trip_types = [] //TODO: Trip Types = where does this info come from? Type are IsLeanIn, Is Strenuous, IsFastPaced but are notated by a series of numbers

					return program
				})

				data = data.filter((program) => {
					if (program.Code) return program.Code === fieldprogram //this.props.booking.EventId;
					return false
				})

				this.setState({
					portOrder: data.length > 0 ? [data[0].Port] : [],
					programs: data,
					totalPrograms: data.length,
				})
			})
			.catch(this.props.handleAxiosLoadError)
	}

	getInventory = () => {
		axios
			.get(apiPath + '/fieldprograms')
			.then((result) => {
				let inventory = {}
				let IDtoCode = {}
				let maxPrice = 0
				// let todaydate = moment()
				let todaydate = new Date();
				todaydate.setHours(0,0,0);
				let blah = result.data
					.sort((a, b) => {
						const aVal = a.isCurrentPrice ? 1 : 0
						const bVal = b.isCurrentPrice ? 1 : 0
						return aVal - bVal
					})
					.map((item) => {
						if (item.EventId !== this.state.voyage) return null
						IDtoCode[item.ItemId] = item.Code
						const price = parseFloat(item.Price)
						const start = item.BegDate
						const end = item.EndDate
						if (price > maxPrice) maxPrice = price
						var theitcenddate = moment(item.itcValidEndDate)

						//check if in inventory already
						// var inventoryitcEndDate = moment(item.itcValidEndDate)
						// 	.add(1, 'days')
						// 	.subtract(1, 'seconds')
						// 	.format('YYYY-MM-DD HH:mm:ss.sss')
						var inventoryitcEndDate	 = new Date(item.itcValidEndDate);
						inventoryitcEndDate.setHours(0,0,0);
						// var inventoryitcEndDate = moment(inventory[item.Code].itcValidEndDate);

						//if the itcvalidate is in the future and its closer to today, or if the inventorydate is in the past
						// if (
						// 	todaydate.diff(inventoryitcEndDate) < 0 &&
						// 	(theitcenddate.diff(inventoryitcEndDate) < 0 ||
						// 		todaydate.diff(inventoryitcEndDate) > 0)
						// ) {
						if (
							todaydate.getTime() < inventoryitcEndDate.getTime() &&
							(theitcenddate.getTime() < inventoryitcEndDate.getTime() < 0 ||
								todaydate.getTime() > inventoryitcEndDate.getTime()) > 0
						) {
							return (inventory[item.Code] = {
								ItemId: item.ItemId,
								Name: item.Name,
								available: parseInt(
									item.AvailItems,
									10
								).toString(),
								price: price,
								isCurrentPrice: todaydate.getTime() < item.itcValidEndDate.getTime() && todaydate.getTime() > item.itcValidBegDate.getTime(),
								// isCurrentPrice: moment().isBetween(
								// 	item.itcValidBegDate,
								// 	moment(item.itcValidEndDate)
								// 		.add(1, 'days')
								// 		.subtract(1, 'seconds')
								// 		.format('YYYY-MM-DD HH:mm:ss.sss')
								// ),
								start: start,
								end: end,
								BegLocation: item.BegLocation,
								EndLocation: item.EndLocation,
								visible: item.Visible,
								bookable: item.Enabled,
								GSCE: item.GSCE,
								duration: item.Duration,
								itcValidBegDate: item.itcValidBegDate,
								itcValidEndDate: moment(item.itcValidEndDate)
									.add(1, 'days')
									.subtract(1, 'seconds')
									.format('YYYY-MM-DD HH:mm:ss.sss'),
							})
						} else {
							return (inventory[item.Code] = {
								ItemId: item.ItemId,
								Name: item.Name,
								available: parseInt(
									item.AvailItems,
									10
								).toString(),
								price: price,
								isCurrentPrice: item.isCurrentPrice,
								start: start,
								end: end,
								visible: item.Visible,
								bookable: item.Enabled,
								GSCE: item.GSCE,
								duration: item.Duration,
								itcValidBegDate: item.itcValidBegDate,
								itcValidEndDate: item.itcValidEndDate,
							})
						}
					})
				this.setState({
					inventory: inventory,
					inventoryLoaded: true,
					IDtoCode: IDtoCode,
					maxPrice: maxPrice,
				})
			})
			.catch(this.props.handleAxiosLoadError)
	}

	getFieldPrograms = (page, filters) => {
		if (document.getElementsByClassName('ant-breadcrumb')[0]) {
			window.scrollTo(
				0,
				window.scrollY +
					document
						.getElementsByClassName('ant-breadcrumb')[0]
						.getBoundingClientRect().top
			)
		}
		let allPrograms = parseJSON(sessionStorage.fieldProgramsAdmin, [])

		allPrograms = allPrograms.filter((program) => {
			if (program.CruiseId)
				return (
					program.CruiseId ===
					sessionStorage.fieldProgramsForVoyageAdmin
				) //this.props.booking.EventId;
			return false
		})

		allPrograms = allPrograms.filter((program) => {
			if (program.CruiseId)
				return (
					program.CruiseId ===
					sessionStorage.fieldProgramsForVoyageAdmin
				) //this.props.booking.EventId;
			return false
		})

		this.setState({
			totalPrograms: allPrograms.length,
			programs: this.props.noPagination
				? allPrograms
				: allPrograms.slice(
						(page - 1) * this.state.displayPageSize,
						page * this.state.displayPageSize
				  ),
		})
	}

	componentWillMount() {
		window.moment = moment

		this.setState({
			voyage: this.props.match.params.voyageid,
			programcode: this.props.match.params.programcode,
		})

		this.getProgamsSimple(
			this.props.match.params.voyageid,
			this.props.match.params.programcode
		)

		this.getInventory()
	}

	componentDidMount() {
		if (window.top !== window.self) this.startPageHeightReporting()
	}

	render() {
		const disabled =
			this.props.variant !== 'admin' &&
			typeof this.props.sectionIsEnabled === 'function' &&
			!this.props.sectionIsEnabled(this.props, 'field/browse')
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(
				this.props,
				'field/browse'
			)
			if (redirect) return redirect
		}
		const rule =
			this.props.configRules &&
			this.props.configRules.find(
				(rule) => rule.section === 'field/browse'
			)
		const fieldProgramsOpen = !rule
			? false
			: rule.enableAlways === '1'
			? true
			: moment().isBetween(
					moment.utc(rule.enableFrom),
					moment.utc(rule.disableAfter)
			  )
		const deadlinePassed = !rule
			? false
			: rule.enableAlways === '1'
			? false
			: moment().isAfter(moment.utc(rule.disableAfter))
		const filterColumnProps = {
			xs: 24,
			sm: 12,
			md: 8,
			style: { padding: '4pt' },
		}
		const noTopBanners =
			typeof this.props.noTopBanners !== 'undefined'
				? this.props.noTopBanners
				: false
		const shouldShowSpotsLeft =
			typeof this.props.showSpotsLeft !== 'undefined'
				? this.props.showSpotsLeft && fieldProgramsOpen
				: this.props.variant === 'admin'
				? true
				: moment().isAfter(
						moment.utc(rule.enableFrom).add(48, 'hours')
				  ) && fieldProgramsOpen
		let priceRange = { 0: '$0' }
		priceRange[this.state.maxPrice] = '$' + this.state.maxPrice
		let colClassNames = ['programCardCol']
		if (shouldShowSpotsLeft) colClassNames.push('taller')

		const programsMissingRescoData = this.state.programs.filter(
			(program) =>
				program.Code !== '-' &&
				Object.keys(this.state.inventory).length &&
				!this.state.inventory[program.Code]
		)

		return (
			<ProgramCardList
				programs={this.state.programs}
				//no more global studies***
				//blocked={(inventoryItem) => this.props.GSCNeeded && !this.props.GSCused}
				booking={this.props.booking}
				bookedItems={this.props.bookedItems}
				cart={this.state.cart}
				inventory={this.state.inventory}
				// old global studies should show cart button***
				// shouldShowCartButtons={
				// 	!this.props.noCartButtons &&
				// 	(this.props.GSCused || this.props.GSCneeded === false) &&
				// 	fieldProgramsOpen && !deadlinePassed
				// }
				shouldShowCartButtons={
					!this.props.noCartButtons &&
					fieldProgramsOpen &&
					!deadlinePassed
				}
				cardProps={{
					loading: this.state.inventoryLoaded !== true,
					onCartAdd: this.handleAddToCart,
					showPrice: true,
					showSpotsLeft: shouldShowSpotsLeft,
					showBanners:
						typeof this.props.showBanners !== 'undefined'
							? this.props.showBanners
							: true,
					onImageLoadAttempt: this.handleImageLoadAttempt,
					onImageLoadSuccess: this.handleImageLoadSuccess,
					loadingOtherImages: this.state.loadingImages.length,
				}}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./portal-components/Portal/FieldAdmin/PreviewProgram/index.jsx